module.exports = __webpack_public_path__ + "static/media/huneeus-small.8fe005a8.jpg";